import { ChangeDetectionStrategy, Component } from "@angular/core";
import { PermitType } from "@ha/data/basic";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Navigate } from "@ngxs/router-plugin";
import { Select, Store } from "@ngxs/store";
import { Observable, take } from "rxjs";

import { PermitPaths } from "../../../../permit-paths";
import { PermitStepActions } from "../../../../permit/states/permit-step.action";
import { PermitUserSelectors } from "../../../../shared/states/permit-user.selectors";
import { PermitWorkPlaceViewEnum } from "../../../models/permit-work-place-view.enum";
import { PermitCreateService } from "../../../services/permit-create.service";
import { PermitCreateSelectors } from "../../../states/permit-create.selectors";
import { PermitWorkplaceActions } from "../../../states/permit-workplace.actions";

@UntilDestroy()
@Component({
    selector: "pmt-workplace-start",
    templateUrl: "permit-workplace-start.component.html",
    styleUrls: ["permit-workplace-start.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitWorkplaceStartComponent {
    @Select(PermitUserSelectors.isPremiumIssuer)
    public isPremiumIssuer$: Observable<boolean>;

    @Select(PermitUserSelectors.isPremiumSuperintendent)
    public isPremiumSuperintendent$: Observable<boolean>;

    @Select(PermitCreateSelectors.isPremium)
    public isPremium$: Observable<boolean>;

    @Select(PermitUserSelectors.canCreateBaseOrDemoPermits)
    public canCreateBaseOrDemoPermits$!: Observable<boolean>;

    constructor(private store: Store, private permitCreateService: PermitCreateService) {}

    public basePermit() {
        this.store.dispatch(new PermitWorkplaceActions.ChangeView(PermitWorkPlaceViewEnum.Base));
    }

    public premium() {
        this.store.dispatch(new PermitWorkplaceActions.ChangeView(PermitWorkPlaceViewEnum.Premium));
    }

    public goBack(): void {
        const permit = this.store.selectSnapshot(PermitCreateSelectors.permit);

        if (permit?.type === PermitType.flammableAtex && !permit.returnToPermitId) {
            this.permitCreateService.removePlannedPermit(permit.id).pipe(
                take(1),
                untilDestroyed(this),
            ).subscribe((result) => {
                if (!result.success) {
                    return;
                }

                this.store.dispatch(new Navigate([PermitPaths.Root]));
            });
            return;
        }

        this.store.dispatch(new PermitStepActions.GoBackwards());
    }
}
